import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ContentTranslaterComponent } from "../../../shared-ui/content-translater/content-translater.component";
import { DatePipe, JsonPipe } from '@angular/common';
import { DateFormatEnum } from 'src/app/core/helpers/date-format-enum';
import { TaskDetailsValidationForm } from 'src/app/core/models/task-details-validation-form';
import { UserRoleEnum } from 'src/app/core/models/enum/user-role-enum';
import { QuillViewComponent } from 'ngx-quill';
import { ConsultantRole } from 'src/app/core/models/consultant-role';



@Component({
  selector: 'app-validation-modal-task-details',
  standalone: true,
  imports: [TranslatePipe, ContentTranslaterComponent, DatePipe, QuillViewComponent],
  templateUrl: './validation-modal-task-details.component.html',
  styleUrl: './validation-modal-task-details.component.scss'
})
export class ValidationModalTaskDetailsComponent{

    public dateFormatEnum = DateFormatEnum;
    public showMore = false;
  constructor() {

  }

  @Input() taskDetails: TaskDetailsValidationForm;
  @Input() paymentDetails: string | null;
  @Input() formTaskDescripion: string;
  @Input() validationFormLang: string;
  @Input() userEnum: UserRoleEnum;
  @Input() consultantForTask: ConsultantRole;


  private consultantLabeltranslations = {
    en: {
      taskDetails: "Task details",
      customer: "Customer",
      role: "Role",
      startDate: "Start date",
      timePerWeek: "Hours p/week",
      location:"Location",
      languageRequirement:"Language requirement",
      endDate: "End date",
      taskDescription: "Task description",
      paymentConditions: "Payment conditions",

    },
    da: {
        taskDetails: "Opgavedetaljer",
        customer: "Kunde",
        role: "Rolle",
        startDate: "Startdato",
        timePerWeek: "Timer pr.uge",
        location:"Lokation",
        languageRequirement:"Sprog krav",
        endDate: "Slutdato",
        taskDescription: "Opgavebeskrivelse",
        paymentConditions: "Betalingsbetingelser",

    }
  };

  public UserRoleEnum = UserRoleEnum;

 public toggleReadMore() {
  this.showMore = !this.showMore;

}

getConsultantLabel(key: string){
  if(this.validationFormLang) {
      return this.consultantLabeltranslations[this.validationFormLang][key];

  }
}

}


